import PropTypes from 'prop-types';
import TextArea from '../../Testimonial/TestimonialOrders/TestiReview/textArea';
/* import ReactStars from "react-rating-stars-component"; */
import { Col, Row } from 'react-bootstrap';
import React from 'react';
import './reviewstars.css';

const Reviewstars = ({ id }) => {
  /*   const [rating, setRating] = useState(0);
  
    const handleRatingChange = (newRating) => {
      setRating(parseFloat(newRating));
    }; */

  /*   const renderStars = () => (
      <ReactStars
        count={5}
        onChange={handleRatingChange}
        size={28}
        isHalf
        classNames={"reviewStars"}
        a11y
        emptyIcon={<i className="far fa-star" />}
        halfIcon={<i className="fa fa-star-half-alt" />}
        fullIcon={<i className="fa fa-star" />}
        activeColor="#ffd700"
        value={rating}
      />
    ); */

  return (
    <>
      <Row className="reviewProduct">
        {/*         <Col xs="12" md="4" lg="3" xl="auto">
          <div className="titleReviewStars">Rate this Flower:</div>
          {renderStars()}
        </Col> */}
        <Col>
          <TextArea id={String(id)} />
        </Col>
      </Row>
      {/*       <input type="hidden" name={`review_${id}`} value={rating} /> */}
    </>
  );
};

Reviewstars.propTypes = {
  id: PropTypes.string.isRequired,
};

export default Reviewstars;
